import { Anchor, Group, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { SearchEngineURL } from "~/pages/Brand/OrganizationSettings/ProductPages/ProductSheetsAccess/SearchEngineUrl.tsx"

interface Props {
  settings: OrganizationsResponses.Organization["settings"]
}
export const ProductSheetsAccess = ({ settings }: Props) => {
  const { t } = useTranslation("organizationSettings")

  return (
    <Stack pb={32} gap="xs">
      <Group>
        {settings.agecProductPagePlan === "ADVANCED" ? (
          <Group pt={12} w="100%">
            <Text>{t("customerInformation.qrCode.label")}: </Text>
            <Anchor component={Link} to="/products/agec">
              {t("customerInformation.qrCode.value")}
            </Anchor>
          </Group>
        ) : undefined}
        <Text c="gray" fz="sm">
          {t("contactSupport")}
        </Text>
      </Group>
      {settings.agecProductPagePlan === "STARTER" ? (
        <Text>{t("agec.starterPlan")}</Text>
      ) : (
        settings.displaySettings
          .filter((ds) => ds.searchEngine)
          .map((displaySetting) => (
            <SearchEngineURL
              key={displaySetting.id}
              displaySetting={displaySetting}
              settings={settings}
            />
          ))
      )}
    </Stack>
  )
}
